import { InjectionToken, Type } from '@angular/core';
import { TcV2CheckoutLinkAccountDialogComponent } from '@features/transfer-connect-v2/containers/checkout-link-account-dialog/checkout-link-account-dialog.component';

export const TCV2_CHECKOUT_LINKED_ACCOUNT_DIALOG = new InjectionToken<
  Type<any>
>('TCV2_CHECKOUT_LINKED_ACCOUNT_DIALOG', {
  factory: () => TcV2CheckoutLinkAccountDialogComponent,
});
